import { useMemo } from 'react';
import { useShopData } from './useShopData';

export const useShopPlanInfo = () => {
    const { data: shopData, isLoading } = useShopData();
    const shopPlanInfo = shopData?.shop_plan;

    const isShopifyPlusUser = useMemo(() => {
        if (isLoading || !shopPlanInfo) {
            return false;
        }

        return Boolean(shopPlanInfo.shopifyPlus);
    }, [shopPlanInfo, isLoading]);

    const isPartnerDevelopmentUser = useMemo(() => {
        if (isLoading || !shopPlanInfo) {
            return false;
        }

        return Boolean(shopPlanInfo.partnerDevelopment);
    }, [shopPlanInfo, isLoading]);

    return {
        isShopifyPlusUser,
        isPartnerDevelopmentUser,
        isLoading,
    };
};
